import { createAnnotation } from "@pages/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleStoryElementProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact } from "html-react-parser";

type ArticleParagraphProps = Omit<
  ArticleStoryElementProps,
  "totalParagraphs" | "paragraphCount" | "article"
>;

/**
 * Renders a paragraph element in an article.
 * This component processes the body string and applies annotations to the text.
 * It uses HTML parsing to convert the string into React elements.
 */
const ArticleParagraph = ({
  bodyString,
  className,
}: ArticleParagraphProps): React.ReactElement => {
  const transformAnnotation = createAnnotation({});

  const transformList = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "p") {
      const el = node;
      const children = el.children as DOMNode[];

      return (
        <p
          className={cn("mb-6 whitespace-pre-wrap break-words", className)}
          data-testid="article-paragraph-component"
        >
          {domToReact(children, {
            replace: transformAnnotation,
          })}
        </p>
      );
    }
  };

  return <>{parse(bodyString, { replace: transformList })}</>;
};

export default ArticleParagraph;
